import { authStore, clearAuthState } from "./store";
import { queryClient } from "@/lib/queryClient";
import { meQueryKey } from "@/lib/me";
import { api } from "@/lib/api";

export {
  authStore,
  initAuthStore,
  getFreshAccessToken,
  refreshAuthSession,
  setAuthSessionForLogin,
} from "./store";

export async function signOut(): Promise<void> {
  queryClient.removeQueries({ queryKey: meQueryKey });
  await api("/auth/logout", { method: "POST" }).catch(() => undefined);
  clearAuthState();
  window.location.assign("/");
}

export function isAuthenticated(): boolean {
  return authStore.isAuthenticated();
}

